import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import LiveChatCampaignsPage from './pages/LiveChatCampaignsPage.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import SMSStatusReportPage from './pages/SMSStatusReportPage.vue';
import WhatsAppStatusReportPage from './pages/WhatsAppStatusReportPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator', 'campaign_manage'],
  module: 'campaigns',
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'campaigns_ongoing_index', params: to.params };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_sms_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'sms',
          name: 'campaigns_sms_index',
          meta,
          redirect: to => {
            return { name: 'sms_configuration', params: to.params };
          },
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta,
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'sms_reports',
          name: 'campaigns_sms_reports_index',
          meta,
          component: SMSStatusReportPage,
        },
        {
          path: 'whatsapp_reports',
          name: 'campaigns_whatsapp_reports_index',
          meta,
          component: WhatsAppStatusReportPage,
        },
        {
          path: 'templates',
          name: 'campaigns_templates_index',
          meta,
          component: () => import('./pages/templates/CustomTemplatesIndex.vue'),
        },
      ],
    },
  ],
};

export default campaignsRoutes;
